'use client';
import {Provider} from 'react-redux';
import {initializeStore, useStore} from './store';

const StoreProvider = ({initState, children}: StoreProviderProps) => {
  const initialState = initializeStore(initState ?? {}).getState();
  const store = useStore(initialState);

  return <Provider store={store}>{children}</Provider>;
};

export default StoreProvider;

interface StoreProviderProps {
  initState?: object;
  children: React.ReactNode;
}
